import "./App.css";
import PrimeReact from "primereact/api";
import React, { useReducer, useEffect, useState, useMemo } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Login } from "./app/components/login/login";
import { ResetPassword } from "./app/components/reset-password/reset-password";
import { ChangePassword } from "./app/components/change-password/change-password";
import { CustomToast } from "./app/shared/components/alert/custom-toast";
import { MainApp } from "./app/main-app/main-app";
import { reducer } from "./app/core/redux/reducer/reducer";
import { initialState } from "./app/core/redux/state/state";
import { LOCAL_STORAGE_SERVICE } from "./app/core/services/storage-service";
import CacheBuster from "react-cache-buster";
import packageJson from "../package.json";
import axios from "axios";
import { TwoFactor } from "./app/components/login/two-factor/two-factor";
const { version } = packageJson;

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      if (window.location.pathname !== "/login") {
        localStorage.clear();
        window.location.href = "/login?session_expired=true";
      }
    }
    return Promise.reject(error);
  }
);

export const MainContext = React.createContext();
PrimeReact.ripple = true;
PrimeReact.zIndex = {
  modal: 1100, // dialog, sidebar
  overlay: 1000, // dropdown, overlaypanel
  menu: 1000, // overlay menus
  tooltip: 1100, // tooltip
  toast: 1200, // toast
};
PrimeReact.autoZIndex = true;
PrimeReact.appendTo = "self"; // Default value is null(document.body).

const checkPermission = () => {
  if (!("serviceWorker" in navigator)) {
    throw new Error("No service worker present!");
  }
  if (!("Notification" in window)) {
    throw new Error("No supoort for notification API!");
  }
};

const registerServiceWorker = async () => {
  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    console.log("Service worker registered:", registration);
    return registration;
  } catch (error) {
    console.log("Error", error);
  }
};

const main = async () => {
  if (Notification.permission === "default") {
    checkPermission();
    await Notification.requestPermission();
    await registerServiceWorker();
  }
};

main();

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(true);
  const isProduction = process.env.NODE_ENV === "production";

  function checkIfAuthenticated() {
    let isAuthenticated = state.isAuthenticated;
    if (!isAuthenticated) {
      isAuthenticated = LOCAL_STORAGE_SERVICE.IS_LOGIN();
      setIsUserAuthenticated(isAuthenticated);
    }
    return isAuthenticated;
  }

  useEffect(() => {
    function setDocumentTitle() {
      const appName = document?.getElementById("app-name")?.innerHTML;
      if (appName) {
        document.title = appName;
      }
    }
    function setUserData() {
      const credentials = LOCAL_STORAGE_SERVICE.GET_USER_CREDENTIALS();
      dispatch({ type: "PERSIST_LOGIN_DATA", loginData: credentials });
    }
    if (isUserAuthenticated) {
      setUserData();
    }
    setDocumentTitle();
  }, [isUserAuthenticated]);

  const contextValue = useMemo(() => ({ mainState: state, mainDispatch: dispatch }), [state, dispatch]);

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
    >
      <div className="App">
        {state.alert.showAlert && (
          <CustomToast
            title={state.alert.title}
            description={state.alert.description}
            type={state.alert.type}
          />
        )}

        <Router>
          <div>
            <MainContext.Provider
              value={contextValue}
            >
              <Switch>
                <Route
                  exact
                  path="/change-password"
                  component={ChangePassword}
                />

                <Route exact path="/login" component={Login} />
                <Route
                  exact
                  path="/login/second-factor"
                  component={TwoFactor}
                />
                <Route exact path="/reset-password" component={ResetPassword} />
                <Route
                  path="/"
                  render={() =>
                    checkIfAuthenticated() ? <MainApp /> : <Login />
                  }
                />
              </Switch>
            </MainContext.Provider>
          </div>
        </Router>
      </div>
    </CacheBuster>
  );
}

export default App;
